module.exports = __webpack_public_path__ + "5b56c201c5b7174e6a7ba474653feb21.pdf";